<div mat-dialog-title>
    {{title|translate}}
    <mat-divider></mat-divider>
</div>
<div mat-dialog-content [ngStyle]="{'min-width':'500px'}" class="bg-secondary">

    <input #file type="file" [ngStyle]="{display:'none'}" [accept]="accept" (change)="fileChangeEvent($event)">
    <div class="d-flex justify-content-end align-items-center p-2 gap-2">
        <div *ngIf="file.files&&file.files.length>0">
            <span>
                {{file.files[0].name}}
            </span>
            <span>
                <button mat-icon-button (click)="file.value=null">
                    <mat-icon [matTooltip]="'DELETE'|translate">clear</mat-icon>
                </button>
            </span>

        </div>
        <md-button [disabled]="isLoading" [color]="'primary-stroked'" (click)="file.click()">{{'CHOOSE_FILE'|translate}}
        </md-button>
    </div>

    <div class="p-4" *ngIf="isLoading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <div class="p-4" *ngIf="result.message">
        <div class="alert" [ngClass]="{'alert-info':result.status==200,'alert-danger':result.status!=200}">
            {{result.message}}
        </div>
    </div>
</div>
<div mat-dialog-actions class="d-flex justify-content-end gap-2 bg-primary">
    <md-button [disabled]="isLoading" [color]="'primary'" (click)="uploadFile(file)">
        <mat-icon>check_circle_outline</mat-icon> {{'SAVE'|translate}}
    </md-button>
    <md-button [disabled]="isLoading" [color]="'warn'" (click)="close()">
        <mat-icon>close</mat-icon> {{'CLOSE'|translate}}
    </md-button>
</div>